import React, {useState} from 'react';
import {useAuth} from '../context/AuthContext';
import {useNavigate, useLocation} from 'react-router-dom';


function Login() {
    const location = useLocation();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(location.state?.error || '');
    const navigate = useNavigate();
    const {login} = useAuth();
    const [isLoading, setIsLoading] = useState(false);


// Parent Component: Login
    const handleLogin = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            await login(username, password, navigate);
        } catch (error) {
            if (error.response && error.response.status === 429) {
                console.error('Zu viele Login-Versuche. Bitte versuche es später erneut.');
                setError('Zu viele Login-Versuche. Bitte versuche es später erneut.');
            } else {
                console.error('Anmeldung fehlgeschlagen:', error);
                setError('Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.');
            }
        } finally {
            setIsLoading(false); // Ladezustand auf false setzen, egal ob erfolgreich oder nicht
        }
    };


    return (
        <div className="min-h-screen w-full bg-black flex flex-col items-center justify-center p-4">
            <div className="w-[90%] max-w-md mx-auto flex flex-col items-center justify-center">
                {/* Logo */}
                <div className="w-full flex justify-center mb-12">
                    <img
                        src="/AES.svg"
                        alt="AES Logo"
                        className="h-30"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = '/fallback-logo.png';
                        }}
                    />
                </div>

                {/* Login Form */}
                <form onSubmit={handleLogin} className="w-full space-y-6">
                    {/* Username input */}
                    <div className="w-full flex justify-center">
                        <input
                            type="text"
                            name="username"
                            placeholder="Benutzername"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className={`w-full px-4 py-2 bg-[#D9D9D9] rounded text-center focus:outline-none focus:ring-2 focus:bg-blue-200 ${
                                error && !username ? 'border-2 border-red-500' : ''
                            }`}
                            disabled={isLoading}
                            autoComplete="username"
                        />
                    </div>

                    {/* Password input */}
                    <div className="w-full flex justify-center">
                        <input
                            type="password"
                            name="password"
                            placeholder="Passwort"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={`w-full px-4 py-2 bg-[#D9D9D9] rounded text-center focus:outline-none focus:ring-2 focus:bg-blue-200 ${
                                error && !password ? 'border-2 border-red-500' : ''
                            }`}
                            disabled={isLoading}
                            autoComplete="current-password"
                        />
                    </div>


                    {/* Error Message */}
                    {error && (
                        <div className="text-red-500 text-sm text-center bg-red-100 p-2 rounded">
                            {error}
                        </div>
                    )}

                    {/* Login Button */}
                    <div className="w-full flex justify-center">
                        <button
                            type="submit"
                            className={`w-full py-2 rounded focus:outline-none transition duration-150 bg-blue-700 hover:bg-teal-400 text-white`}
                            disabled={isLoading}

                        >
                            Login


                        </button>
                    </div>
                    {/* Loading Spinner */}
                    {isLoading && (
                        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75">
                            <svg
                                className="animate-spin h-10 w-10 text-black"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0
                                12h4zm2 5.291A7.962 7.962 0 014
                                12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                            </svg>
                        </div>
                    )}


                </form>
            </div>
        </div>
    );
};

export default Login;